export const ID = '88beef61-5d72-4612-9103-1b23a6c121cb';

export const NAME = 'Pay Online';

export const OPTION_IFRAME = 'iframe';
export const OPTION_LINKOUT = 'linkout';
export const OPTION_DEFAULT = OPTION_IFRAME;

export const OPTION_NAME = 'payOption';
